var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('p',[_vm._v("Email Address:")]),_c('p',[_vm._v(_vm._s(_vm.payload.content))]),_c('button',{staticClass:"button is-info is-outlined mt-5",on:{"click":_vm.createCompany}},[_vm._v("Create new resource")])])
}
var staticRenderFns = []

export { render, staticRenderFns }